
import EditorTipTap from 'Editors/EditorTipTap'

export default {
  components: {
    EditorTipTap,
  },
  data() {
    return {
      slides: [],
      swiperOptions: {
        slidesPerView: 1.5,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'custom',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1024: {
            slidesPerView: 4.7,
            spaceBetween: 32,
          },
          720: {
            slidesPerView: 3.7,
            spaceBetween: 32,
          },
          500: {
            slidesPerGroup: 3,
            slidesPerView: 3,
            spaceBetween: 28,
          },
        },
      },
      options: [
        {
          name: 'logo',
          label: 'Logo',
          type: 'image',
        },
      ],
    }
  },
  mounted() {
    if (this.$refs && this.$refs.editorList) {
      if (this.$refs.editorList.items && this.$refs.editorList.items.length) {
        this.slides = this.$refs.editorList.items
      }
    }
  },
}
